import { render, staticRenderFns } from "./SCtePneu.vue?vue&type=template&id=8832c4be"
import script from "./SCtePneu.vue?vue&type=script&lang=js"
export * from "./SCtePneu.vue?vue&type=script&lang=js"
import style0 from "./SCtePneu.vue?vue&type=style&index=0&id=8832c4be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports